import React from "react";
import ReactImageFallback from "react-image-fallback";

import { AppConfig } from "app/NativeActions";
import { store } from "app/store";

const md5 = require("js-md5");

const getThumbnail = (image, use_full) => {
  if (
    image.startsWith("https://dealmachine.s3.amazonaws.com") &&
    use_full == false
  ) {
    var thumbnail = AppConfig().api_url + "image/?url=" + image + "&type=thumb";
    return thumbnail;
  }

  return image;
};

const ProfilePic = ({ email, image, size, mask, use_full = false, style }) => {
  var url = "";
  if (image && image != "") {
    url = getThumbnail(image, use_full);
  } else if (email && email != "") {
    var hash = md5(email);
    url = "https://www.gravatar.com/avatar/" + hash + "?s=100.jpg&d=mm";
  } else {
    url = "https://www.gravatar.com/avatar/?s=100.jpg&d=mm";
  }

  const dark_mode = store.getState().settings.dark_mode;

  return (
    <div
      className="dm-profile-image"
      style={{ ...style, opacity: dark_mode == "dark_mode" ? 0.6 : 1 }}
    >
      <ReactImageFallback
        style={{
          width: size || 60,
          height: size || 60,
          borderRadius: size ? size / 2 : 30
        }}
        src={url}
        fallbackImage="/assets/images/default.svg"
      />
    </div>
  );
};

export { ProfilePic };
